import {Maybe} from '@coolcolduk/typescript-util';
import {UserPermission, type User} from '@cp/model';

export function hasUserPermission(user: Maybe<User> | undefined, requiredPermission: UserPermission): boolean {
  return user?.roles?.includes(requiredPermission) ?? false;
}

export function hasAnyUserPermission(user: Maybe<User> | undefined, requiredPermissions: UserPermission[]): boolean {
  return requiredPermissions.some((permission) => hasUserPermission(user, permission));
}
